/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Salary_Search_AnalyzingInputs */

const en_salary_search_analyzing = /** @type {(inputs: Salary_Search_AnalyzingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyzing...`)
};

const de_salary_search_analyzing = /** @type {(inputs: Salary_Search_AnalyzingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyse...`)
};

const fr_salary_search_analyzing = /** @type {(inputs: Salary_Search_AnalyzingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyse en cours...`)
};

const es_salary_search_analyzing = /** @type {(inputs: Salary_Search_AnalyzingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analizando...`)
};

const it_salary_search_analyzing = /** @type {(inputs: Salary_Search_AnalyzingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analisi...`)
};

const nl_salary_search_analyzing = /** @type {(inputs: Salary_Search_AnalyzingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyseren...`)
};

const pl_salary_search_analyzing = /** @type {(inputs: Salary_Search_AnalyzingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analizowanie...`)
};

const fi_salary_search_analyzing = /** @type {(inputs: Salary_Search_AnalyzingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analysoidaan...`)
};

const da_salary_search_analyzing = /** @type {(inputs: Salary_Search_AnalyzingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyserer...`)
};

const sv_salary_search_analyzing = /** @type {(inputs: Salary_Search_AnalyzingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyserar...`)
};

/**
* | output |
* | --- |
* | "Analyzing..." |
*
* @param {Salary_Search_AnalyzingInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const salary_search_analyzing = /** @type {((inputs?: Salary_Search_AnalyzingInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Salary_Search_AnalyzingInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_salary_search_analyzing(inputs)
	if (locale === "fr") return fr_salary_search_analyzing(inputs)
	if (locale === "es") return es_salary_search_analyzing(inputs)
	if (locale === "it") return it_salary_search_analyzing(inputs)
	if (locale === "nl") return nl_salary_search_analyzing(inputs)
	if (locale === "pl") return pl_salary_search_analyzing(inputs)
	if (locale === "fi") return fi_salary_search_analyzing(inputs)
	if (locale === "da") return da_salary_search_analyzing(inputs)
	if (locale === "sv") return sv_salary_search_analyzing(inputs)
	return en_salary_search_analyzing(inputs)
});